module.exports = __webpack_public_path__ + "img/del.9f76cfa8.svg";